import HttpService from '../../core/services/HttpService';
import LegacyNotificationChannel from "../../organization/models/LegacyNotificationChannel";
import HttpCallConfig from "../../core/models/HttpCallConfig";

const httpService = HttpService.Instance;

async function handlePossibleAPIErrors(response: Response) {
    if (response.ok) {
        return;
    }

    let body;
    try {
        body = await response.json();
    } catch { /* @ts-ignore */ }

    if (body && body.error) {
        throw new Error(body.error);
    }
    throw new Error(response.statusText);
}

class LegacyNotificationManagementService {
    public static async GetNotificationChannels() {
        const response = await httpService.get(
            process.env.REACT_APP_API_URL +
            'legacynotifications/notificationchannels'
        );

        await handlePossibleAPIErrors(response);

        return response.json();
    }

    public static async GetNotificationChannelById(id : string) {
        const response = await httpService.get(
            process.env.REACT_APP_API_URL +
            'legacynotifications/notificationchannel/' + id
        );

        await handlePossibleAPIErrors(response);

        return response.json();
    }

    public static async PostNotificationChannel(notificationChannel : LegacyNotificationChannel, httpCallConfig: HttpCallConfig) {
        const response = await httpService.post(
            process.env.REACT_APP_API_URL + 'legacynotifications/notificationchannel',
            notificationChannel, httpCallConfig
        );

        await handlePossibleAPIErrors(response);

        return response;
    }

    public static async PutNotificationChannel(id: string, notificationChannel: LegacyNotificationChannel, httpCallConfig: HttpCallConfig) {
        const response = await httpService.put(
            process.env.REACT_APP_API_URL + 'legacynotifications/notificationchannel/' + id,
            notificationChannel, httpCallConfig
        );

        await handlePossibleAPIErrors(response);

        return response;
    }

    public static async DeleteNotificationChannel(id: string, httpCallConfig: HttpCallConfig) {
        return await httpService.delete(process.env.REACT_APP_API_URL + 'legacynotifications/notificationchannel/' + id, httpCallConfig);
    }
}

export default LegacyNotificationManagementService;


// WEBPACK FOOTER //
// ./src/modules/shared/services/LegacyNotificationManagementService.tsx